

export default function switchTheme() {


    const root = document.documentElement;
    const switchThemes = document.querySelectorAll('.js-switch-theme');
    const switchHeaders = document.querySelectorAll('.js-switch-header');
    const header = document.querySelector('.header');

    const test = document.querySelectorAll('.js-test');
    const test2 = document.querySelectorAll('.js-test2');
    
    if ( root ) {
        
        if ( switchThemes.length ) {
            
            for (let btn of switchThemes ) {
                
                btn.addEventListener('click',function(){
                    let theme = btn.dataset.theme;

                    if ( theme == 9 ) {
                        document.body.classList.add('light-theme');

                        root.style.setProperty('--white',       '#ffffff');
                        root.style.setProperty('--text',        '#000000');
                        root.style.setProperty('--main',        '#0033AB');
                        root.style.setProperty('--mainDark',    '#083EBD');
                        root.style.setProperty('--bg',          '#EBEBF3');
                        root.style.setProperty('--blur',        '0px');
                        root.style.setProperty('--border',    '#00000022');
                        root.style.setProperty('--bgSecond',    '#EBEBF3');
                        //root.style.setProperty('--whiteOpacity',    '#ffffff');
                        root.style.setProperty('--gradient',    '#ffffff');
                        root.style.setProperty('--gradient4',    'linear-gradient(180deg, rgba(0, 70, 235, 0) 0%, rgba(0, 70, 235, 0.2) 100%)');
                        root.style.setProperty('--hover',       'radial-gradient(39.78% 22.83% at 50% 96.74%, #0046EBcc 0%, #0046EB00 100%)');
                    }

                    if ( theme == 0 ) {
                        document.body.classList.remove('light-theme');

                        root.style.setProperty('--white',       '#ffffff');
                        root.style.setProperty('--main',        '#0046EB');
                        root.style.setProperty('--mainDark',    '#083EBD');
                        root.style.setProperty('--bg',          '#020A1A');
                        root.style.setProperty('--bgSecond',    '#101920');
                        root.style.setProperty('--hover',       'radial-gradient(39.78% 22.83% at 50% 96.74%, #0046EBcc 0%, #0046EB00 100%)');
                    }

                    if ( theme == 1 ) {
                        document.body.classList.remove('light-theme');

                        root.style.setProperty('--white',       '#ffffff');
                        root.style.setProperty('--main',        '#e11227');
                        root.style.setProperty('--mainDark',    '#aa0919');
                        root.style.setProperty('--bg',          '#020A1A');
                        root.style.setProperty('--bgSecond',    '#101920');
                        root.style.setProperty('--hover',       'radial-gradient(39.78% 22.83% at 50% 96.74%, #e11227cc 0%, #e1122700 100%)');
                    }

                    if ( theme == 2 ) {
                        document.body.classList.remove('light-theme');

                        root.style.setProperty('--white',       '#ffffff');
                        root.style.setProperty('--main',        '#3F64AE');
                        root.style.setProperty('--mainDark',    '#FFF323');
                        root.style.setProperty('--bg',          '#020A1A');
                        root.style.setProperty('--bgSecond',    '#101920');
                        root.style.setProperty('--hover',       'radial-gradient(39.78% 22.83% at 50% 96.74%, #3F64AEcc 0%, #3F64AE00 100%)');
                    }

                    if ( theme == 3 ) {
                        document.body.classList.remove('light-theme');

                        root.style.setProperty('--white',       '#ffffff');
                        root.style.setProperty('--main',        '#016725');
                        root.style.setProperty('--mainDark',    '#07b75c');
                        root.style.setProperty('--bg',          '#020A1A');
                        root.style.setProperty('--bgSecond',    '#101920');
                        root.style.setProperty('--hover',       'radial-gradient(39.78% 22.83% at 50% 96.74%, #016725cc 0%, #01672500 100%)');
                    }
                    
                });

            }

        }

    }

    if ( switchHeaders.length ) {
        
        for (let btn of switchHeaders ) {

            btn.addEventListener('click',function(){
                let header = btn.dataset.header;

                document.querySelector('body').classList.remove('header-type-one');
                document.querySelector('body').classList.remove('header-type-two');
                document.querySelector('body').classList.remove('header-type-three');

                for (let logo of document.querySelectorAll('.header img') ) {
                    logo.style.display = 'none';
                }

                if ( header == 0 ){
                    document.querySelector('body').classList.add('header-type-one');
                    document.querySelector('.header__club-name span').innerText = 'ФК «Чайка»';
                    document.querySelectorAll('.header img')[3].style.display = 'block';
                }
                if ( header == 1 ){
                    document.querySelector('body').classList.add('header-type-two');
                    document.querySelector('.header__club-name span').innerText = 'ФК «Чайка»';
                    document.querySelectorAll('.header img')[0].style.display = 'block';
                }
                if ( header == 2 ){
                    document.querySelector('body').classList.add('header-type-three');
                    document.querySelector('.header__club-name span').innerText = 'ФК Спартак-нальчик';
                    document.querySelectorAll('.header img')[2].style.display = 'block';
                }
                if ( header == 3 ){
                    document.querySelector('body').classList.add('header-type-two');
                    document.querySelector('.header__club-name span').innerText = 'ФК «Ростов»';
                    document.querySelectorAll('.header img')[1].style.display = 'block';
                }
                if ( header == 4 ){
                    document.querySelector('body').classList.add('header-type-one');
                    document.querySelector('.header__club-name span').innerText = 'ФК «Ростов»';
                    document.querySelectorAll('.header img')[4].style.display = 'block';
                }

            });
            
            

        }

    }




    if ( switchThemes.length ) {
        
        for (let btn of switchThemes ) {
            
            btn.addEventListener('click',function(){
                let theme = btn.dataset.theme;
                let header = btn.dataset.header;

                console.log('theme', theme);
                console.log('header', header);

                document.querySelector('body').classList.remove('header-type-one');
                document.querySelector('body').classList.remove('header-type-two');
                document.querySelector('body').classList.remove('header-type-three');

                for (let logo of document.querySelectorAll('.header img') ) {
                    logo.style.display = 'none';
                }

                for (let footerLogo of document.querySelectorAll('.footer__logo img') ) {
                    footerLogo.style.display = 'none';
                }

                if ( theme == 10 ) {

                    root.style.setProperty('--white',               '#ffffff');
                    root.style.setProperty('--text',                '#ffffff');
                    root.style.setProperty('--main',                '#0046EB');
                    root.style.setProperty('--mainDark',            '#083EBD');
                    root.style.setProperty('--bg',                  '#020A1A');
                    root.style.setProperty('--bgSecond',            '#101920');
                    root.style.setProperty('--gray',                '#BBBBBB');
                    root.style.setProperty('--gray2',               '#EEEEEE');
                    root.style.setProperty('--gray3',               '#F9F9F9');
                    root.style.setProperty('--blur',                '20px');
                    root.style.setProperty('--blurEasy',            '6px');
                    root.style.setProperty('--blurFix',             '20px');
                    root.style.setProperty('--whiteOpacity',        '#ffffff11');
                    root.style.setProperty('--white30',             '#ffffff33');
                    root.style.setProperty('--border',              '#ffffff22');
                    root.style.setProperty('--black30',             '#00000044');
                    root.style.setProperty('--gradient',            'linear-gradient(90.7deg, rgba(0, 0, 0, 0.3) 0%, rgba(88, 88, 88, 0.3) 100%)');
                    root.style.setProperty('--gradient2',           'linear-gradient(90.7deg, rgba(0, 0, 0, 0.5) 0%, rgba(88, 88, 88, 0.5) 100%)');
                    root.style.setProperty('--gradient3',           'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)');
                    root.style.setProperty('--gradient4',           'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 100%)');
                    root.style.setProperty('--hover',               'radial-gradient(39.78% 22.83% at 50% 96.74%, #0046EBcc 0%, #0046EB00 100%)');

                }

                if ( theme == 11 ) {

                    root.style.setProperty('--white',               '#ffffff');
                    root.style.setProperty('--text',                '#ffffff');
                    root.style.setProperty('--main',                '#0046EB');
                    root.style.setProperty('--mainDark',            '#083EBD');
                    root.style.setProperty('--bg',                  '#020A1A');
                    root.style.setProperty('--bgSecond',            '#101920');
                    root.style.setProperty('--gray',                '#BBBBBB');
                    root.style.setProperty('--gray2',               '#EEEEEE');
                    root.style.setProperty('--gray3',               '#F9F9F9');
                    root.style.setProperty('--blur',                '20px');
                    root.style.setProperty('--blurEasy',            '6px');
                    root.style.setProperty('--blurFix',             '20px');
                    root.style.setProperty('--whiteOpacity',        '#ffffff11');
                    root.style.setProperty('--white30',             '#ffffff33');
                    root.style.setProperty('--border',              '#ffffff22');
                    root.style.setProperty('--black30',             '#00000044');
                    root.style.setProperty('--gradient',            'linear-gradient(90.7deg, rgba(0, 0, 0, 0.3) 0%, rgba(88, 88, 88, 0.3) 100%)');
                    root.style.setProperty('--gradient2',           'linear-gradient(90.7deg, rgba(0, 0, 0, 0.5) 0%, rgba(88, 88, 88, 0.5) 100%)');
                    root.style.setProperty('--gradient3',           'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)');
                    root.style.setProperty('--gradient4',           'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 100%)');
                    root.style.setProperty('--hover',               'radial-gradient(39.78% 22.83% at 50% 96.74%, #0046EBcc 0%, #0046EB00 100%)');

                }

                if ( theme == 12 ) {

                    root.style.setProperty('--white',               '#ffffff');
                    root.style.setProperty('--text',                '#ffffff');
                    root.style.setProperty('--main',                '#F71C16');
                    root.style.setProperty('--mainDark',            '#F71C99');
                    root.style.setProperty('--bg',                  '#020A1A');
                    root.style.setProperty('--bgSecond',            '#101920');
                    root.style.setProperty('--gray',                '#BBBBBB');
                    root.style.setProperty('--gray2',               '#EEEEEE');
                    root.style.setProperty('--gray3',               '#F9F9F9');
                    root.style.setProperty('--blur',                '20px');
                    root.style.setProperty('--blurEasy',            '6px');
                    root.style.setProperty('--blurFix',             '20px');
                    root.style.setProperty('--whiteOpacity',        '#ffffff11');
                    root.style.setProperty('--white30',             '#ffffff33');
                    root.style.setProperty('--border',              '#ffffff22');
                    root.style.setProperty('--black30',             '#00000044');
                    root.style.setProperty('--gradient',            'linear-gradient(90.7deg, rgba(0, 0, 0, 0.3) 0%, rgba(88, 88, 88, 0.3) 100%)');
                    root.style.setProperty('--gradient2',           'linear-gradient(90.7deg, rgba(0, 0, 0, 0.5) 0%, rgba(88, 88, 88, 0.5) 100%)');
                    root.style.setProperty('--gradient3',           'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)');
                    root.style.setProperty('--gradient4',           'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 100%)');
                    root.style.setProperty('--hover',               'radial-gradient(39.78% 22.83% at 50% 96.74%, #F71C16cc 0%, #F71C1600 100%)');

                }

                if ( theme == 13 ) {

                    root.style.setProperty('--white',               '#ffffff');
                    root.style.setProperty('--text',                '#ffffff');
                    root.style.setProperty('--main',                '#00A7E2');
                    root.style.setProperty('--mainDark',            '#00A799');
                    root.style.setProperty('--bg',                  '#020A1A');
                    root.style.setProperty('--bgSecond',            '#101920');
                    root.style.setProperty('--gray',                '#BBBBBB');
                    root.style.setProperty('--gray2',               '#EEEEEE');
                    root.style.setProperty('--gray3',               '#F9F9F9');
                    root.style.setProperty('--blur',                '20px');
                    root.style.setProperty('--blurEasy',            '6px');
                    root.style.setProperty('--blurFix',             '20px');
                    root.style.setProperty('--whiteOpacity',        '#ffffff11');
                    root.style.setProperty('--white30',             '#ffffff33');
                    root.style.setProperty('--border',              '#ffffff22');
                    root.style.setProperty('--black30',             '#00000044');
                    root.style.setProperty('--gradient',            'linear-gradient(90.7deg, rgba(0, 0, 0, 0.3) 0%, rgba(88, 88, 88, 0.3) 100%)');
                    root.style.setProperty('--gradient2',           'linear-gradient(90.7deg, rgba(0, 0, 0, 0.5) 0%, rgba(88, 88, 88, 0.5) 100%)');
                    root.style.setProperty('--gradient3',           'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)');
                    root.style.setProperty('--gradient4',           'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 100%)');
                    root.style.setProperty('--hover',               'radial-gradient(39.78% 22.83% at 50% 96.74%, #00A7E2cc 0%, #00A7E200 100%)');

                }



                if ( header == 10 ){
                    document.querySelector('body').classList.add('header-type-one');
                    document.querySelector('.header__club-name span').innerText = 'ФК «Чайка»';
                    document.querySelectorAll('.header img')[3].style.display = 'block';

                    document.querySelectorAll('.footer__logo img')[0].style.display = 'block';
                }





                if ( header == 11 ){
                    document.querySelector('body').classList.add('header-type-two');
                    document.querySelector('.header__club-name span').innerText = 'ФК «Чайка»';
                    document.querySelectorAll('.header img')[0].style.display = 'block';

                    document.querySelectorAll('.footer__logo img')[0].style.display = 'block';
                }


                if ( header == 12 ){
                    document.querySelector('body').classList.add('header-type-three');
                    document.querySelector('.header__club-name span').innerText = 'ФК Спартак-нальчик';
                    document.querySelectorAll('.header img')[1].style.display = 'block';

                    document.querySelectorAll('.footer__logo img')[1].style.display = 'block';
                }


                if ( header == 13 ){
                    document.querySelector('body').classList.add('header-type-three');
                    document.querySelector('.header__club-name span').innerText = 'ФК «Зенит-пенза»';
                    document.querySelectorAll('.header img')[2].style.display = 'block';

                    document.querySelectorAll('.footer__logo img')[2].style.display = 'block';
                }

            
                
            });

        }

    }




    
    /* for (let btn of test ) {
        btn.addEventListener('click',function(){
            alert('1');
        });
    }

    for (let btn of test2 ) {
        btn.addEventListener('click',function(){
            alert('1');
        });
    } */


}